import { mdiAccountMultiple, mdiAccountOutline, mdiCogOutline, mdiDnsOutline, mdiPencilOutline } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import { subject } from '@casl/ability'
import { PRIVATE } from '@/plugins/acl/const'

export default function useEmployeeList() {
  const employees = ref([])
  const choices = ref({})

  const tagsFilter = ref([])
  const statusesFilter = ref([])
  const languagesFilter = ref([])

  const tableColumns = [
    { text: 'user', value: 'fullName', class: 'ps-7 text-uppercase' },
    { text: 'status', value: 'status', class: 'text-uppercase' },
    { text: 'tags', value: 'tags', sortable: false, class: 'text-uppercase' },
    { text: 'phoneNumber', value: 'phoneNumber', class: 'text-uppercase' },
    {
      text: 'actions',
      value: 'actions',
      align: 'center',
      sortable: false,
      class: 'text-uppercase',
    },
  ]

  const searchQuery = ref('')
  const totalUserListTable = ref(0)
  const loading = ref(false)
  const options = ref({
    sortDesc: [true],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  })
  const userTotalLocal = ref([])
  const overview = ref([])

  const { getEmployees, getEmployeeChoices, getEmployeesOverview } = useActions('staff', [
    'getEmployees',
    'getEmployeeChoices',
    'getEmployeesOverview',
  ])

  const fetchEmployeesOverview = async () => {
    overview.value = await getEmployeesOverview()
  }

  // fetch data
  const fetchEmployees = async () => {
    loading.value = true
    const { data, success } = await getEmployees({
      tags: tagsFilter.value,
      status: statusesFilter.value,
      languages: languagesFilter.value,
      search: searchQuery.value,
      page: options.value.page,
      pageSize: options.value.itemsPerPage,
      ordering: options.value.sortBy.map((el, index) => {
        const parsedEl = el
          .replaceAll('.', '__')
          .replace('fullName', 'candidate__user__last_name')
          .replace('phoneNumber', 'candidate__user__phone')

        return `${options.value.sortDesc[index] ? '-' : ''}${parsedEl}`
      }),
    })
    if (success) {
      if (Object.hasOwnProperty.bind(data)('results') && Object.hasOwnProperty.bind(data)('count')) {
        employees.value = data.results.map((employee) => subject(PRIVATE.STAFF.EMPLOYEES, employee))
        totalUserListTable.value = data.count
      } else {
        employees.value = data.map((employee) => subject(PRIVATE.STAFF.EMPLOYEES, employee))
        totalUserListTable.value = data.length
      }
      loading.value = false
    }
    choices.value = await getEmployeeChoices({
      tags: tagsFilter.value,
      status: statusesFilter.value,
      languages: languagesFilter.value,
      search: searchQuery.value,
    })
  }

  const timer = ref(null)
  const delaySearchHandler = async () => {
    clearTimeout(timer.value)
    timer.value = setTimeout(async () => {
      await fetchEmployees()
    }, 1000)
  }

  watch([tagsFilter, statusesFilter, languagesFilter, options], async () => {
    await fetchEmployees()
  })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserTotalIcon = (title) => {
    if (title === 'total') return { icon: mdiAccountMultiple, color: 'secondary' }
    if (title === 'assigned') return { icon: mdiDnsOutline, color: 'primary' }
    if (title === 'files') return { icon: mdiCogOutline, color: 'success' }

    return { icon: mdiAccountOutline, color: 'primary' }
  }

  return {
    fetchEmployeesOverview,
    fetchEmployees,
    resolveUserTotalIcon,
    delaySearchHandler,

    tableColumns,
    searchQuery,
    totalUserListTable,
    loading,
    options,
    userTotalLocal,
    overview,
    employees,
    choices,
    tagsFilter,
    statusesFilter,
    languagesFilter,
  }
}
